import { useSuspenseQuery } from '@tanstack/react-query';
import type { EntityBase } from '@opengov/psp-contract';
import { fetchAllEntitledEntities } from '../services/entityApi';
import { extractBaseEntity } from '../utils/entityUtils';
import type { Logger } from '../types';

export function entitledEntitiesQueryKey(userUuid: string) {
  return ['entitledEntities', userUuid] as const;
}

export function useEntitledEntitiesQuery({
  userUuid,
  getAccessTokenSilently,
  logger,
}: {
  userUuid: string;
  getAccessTokenSilently: () => Promise<string>;
  logger: Logger;
}) {
  return useSuspenseQuery<EntityBase[]>({
    queryKey: entitledEntitiesQueryKey(userUuid),
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const data = await fetchAllEntitledEntities(userUuid, token, logger);
      return data.map(extractBaseEntity);
    },
    staleTime: 2 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
